import { HEADER_BREAK } from '../constants/breakpoints';
export class Header {
    page: HTMLElement;
    pageBody: HTMLBodyElement;
    mainNav: HTMLMenuElement;
    subnavToggle: [];
    mobileNavToggle: HTMLButtonElement;
    intViewportWidth: number;
    scrollPos: number;

    constructor() {
        this.page = document.querySelector('main') as HTMLElement;
        this.pageBody = document.querySelector('html, body') as HTMLBodyElement;
        this.mainNav = document.querySelector('.main-nav') as HTMLMenuElement;
        this.subnavToggle = [].slice.call(document.querySelectorAll('.main-nav-btn'));
        this.mobileNavToggle = document.querySelector('.main-header-mobile-menu-btn') as HTMLButtonElement;
        this.setNav();
    }

    // get viewport width
    getViewportWidth = () => {
        this.intViewportWidth = window.innerWidth;
    }

    // initial nav setup
    setNav = () => {
        this.getViewportWidth();
        if (this.intViewportWidth < HEADER_BREAK) {
            this.mobileNavToggle.setAttribute('aria-expanded', 'false');
            this.mainNav.setAttribute('aria-hidden', 'true');
        }
        else {
            this.mainNav.removeAttribute('aria-hidden');
        }
        this.resetNav();
        this.toggleSubnav();
        this.toggleMobileNav();
        this.setScrollPos();
        this.resetNavOnResize();
    }

    // lock page scroll
    lockPage = () => {
        this.pageBody.classList.add('fixed');
        this.pageBody.style.top = this.scrollPos + 'px';
    }

    // unlock page scroll
    unlockPage = () => {
        this.pageBody.classList.remove('fixed');
        this.pageBody.style.top = '';
        window.scrollTo(0, this.scrollPos);
    }

    // reset subnav 
    resetSubnav = () => {
        const subnav = [].slice.call(document.querySelectorAll('[data-has-subnav]'));
        const subnavLinks = [].slice.call(document.querySelectorAll('[data-has-subnav] a'));
        this.subnavToggle.forEach(toggleItem => {
            const toggle = toggleItem as HTMLButtonElement;
            toggle.setAttribute('aria-expanded', 'false');
        });
        subnav.forEach(navItem => {
            const nav = navItem as HTMLUListElement;
            nav.setAttribute('aria-hidden', 'true');
            nav.style.height = '0';
        });
        subnavLinks.forEach(linkItem => {
            // prevent tabbing to hidden links
            const link = linkItem as HTMLLinkElement;
            link.setAttribute('tabindex', '-1');
        });
        if (this.intViewportWidth > HEADER_BREAK) {
            this.unlockPage();
        }
    }

    // reset nav
    resetNav = () => {
        this.resetSubnav();
        this.page.removeEventListener('click', this.resetNav);
    }

    // scroll header
    setScrollPos = () => {
        let scrolling: boolean = false;

        window.addEventListener('scroll', () => {
            scrolling = true;
        });

        setInterval(() => {
            if (scrolling) {
                scrolling = false;

                // get scroll pos
                if (!this.pageBody.classList.contains('fixed')) {
                    this.scrollPos = window.scrollY;
                }
                // close subnav on desktop scroll
                if (this.intViewportWidth > HEADER_BREAK) {
                    this.resetNav();
                }
            }
        }, 300);
    }

    // subnav toggle
    toggleSubnav = () => {
        const subnavToggler = (target) => {
            if (target.getAttribute('aria-expanded') === 'true') {
                this.resetNav();
            }
            else {
                this.resetNav();
                this.page.addEventListener('click', this.resetNav);
                const itemSubnav = target.nextElementSibling as HTMLElement,
                    itemSubnavContainer = itemSubnav.querySelector('[data-subnav-container]') as HTMLElement,
                    itemSubnavLinks = [].slice.call(itemSubnavContainer.querySelectorAll('a'));
                target.setAttribute('aria-expanded', 'true');
                itemSubnav.setAttribute('aria-hidden', 'false');
                itemSubnav.style.height = itemSubnavContainer.offsetHeight + 'px';
                itemSubnavLinks.forEach(linkItem => {
                    const link = linkItem as HTMLLinkElement;
                    link.setAttribute('tabindex', '');
                });
            }
        }
        this.subnavToggle.forEach(toggleItem => {
            const toggle = toggleItem as HTMLButtonElement;
            toggle.addEventListener('click', (e) => {
                subnavToggler(e.currentTarget);
            });
        });
    }

    // mobile nav toggle
    toggleMobileNav = () => {
        this.mobileNavToggle.addEventListener('click', () => {
            if (this.mobileNavToggle.getAttribute('aria-expanded') === 'true') {
                this.mobileNavToggle.setAttribute('aria-expanded', 'false');
                this.mainNav.setAttribute('aria-hidden', 'true');
                this.resetSubnav();
                this.unlockPage();
            }
            else {
                this.mobileNavToggle.setAttribute('aria-expanded', 'true');
                this.mainNav.setAttribute('aria-hidden', 'false');
                setTimeout(() => {
                    this.lockPage();
                }, 201);
            }
        });
    }

    resetNavOnResize = () => {
        window.addEventListener('resize', () => {
            this.getViewportWidth();
            this.resetNav();
        });
    }
}